import { IShipment } from "models/shipment/shipment.model";
import { recordLabelsDownloaded } from "services/api/labels";
import { AppThunk, RootState } from "store";
import { setLabelsDownloaded } from "../index.slice";

/**
 * Records that a person has just seen these shipments' labels, for the Label
 * Download Date column. Called after the label has been handed over, and must
 * never get in the way of printing, so a failed call is ignored.
 */
export const recordLabelsDownloadedThunk = (
  shipmentIds: IShipment["id"][]
): AppThunk => {
  return async (dispatch, getState) => {
    const {
      authSlice: { salesAccountUUID },
    } = getState() as RootState;

    if (!salesAccountUUID || shipmentIds.length === 0) return;

    dispatch(
      setLabelsDownloaded({
        shipmentIds,
        downloadedAt: new Date().toISOString(),
      })
    );

    try {
      await recordLabelsDownloaded(salesAccountUUID, shipmentIds);
    } catch (error) {
      console.error("Couldn't record the label download", error);
    }
  };
};
